import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";
import { VatMode } from "@/module/Form/VatDeterminer/VatMode";

export default class IsVatPayer {
  private readonly foreignCustomerDeterminer: ForeignCustomerDeterminer;
  private readonly vatMode: VatMode;

  constructor(
    foreignCustomerDeterminer: ForeignCustomerDeterminer,
    vatMode: VatMode,
  ) {
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
    this.vatMode = vatMode;
  }

  isVatPayer(country: string | null) {
    if (this.vatMode === VatMode.VAT_PAYER) {
      return true;
    }

    if (this.vatMode === VatMode.IDENTIFIED_PERSON) {
      return this.foreignCustomerDeterminer.isForeignCustomer(country);
    }

    if (this.vatMode === VatMode.NON_VAT_PAYER) {
      return false;
    }

    throw new Error('Unknown vat mode: "' + this.vatMode + '".');
  }
}
